// extracted by mini-css-extract-plugin
export default {"complianceTable":"FRHr3SKSJhFOewRkwHmA"};